import { render } from "./tableComp.vue?vue&type=template&id=fa2e5020&scoped=true"
import script from "./tableComp.vue?vue&type=script&lang=js"
export * from "./tableComp.vue?vue&type=script&lang=js"

import "./tableComp.vue?vue&type=style&index=0&id=fa2e5020&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa2e5020"]])

export default __exports__